var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0_1942_1641)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1942_1641",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1942_1641",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1942_1641",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAClklEQVR4nO3cS2oUURTG8eOrg6JzNUE0q9CBinsQtyCiUVD3YBtEAkZsh+ImogtQfGAyMShOfRHfhviY5C8X7yhUaTfdes93+/ygJuFCf9+hUlXp7lyzEEIIIYQQQhgXwARwDngIrKFjDXgAnAU65hkwCSyhbxHYYx6lswB4Qj0eA9vMG+AU9Tlp3uQzoDaPzBNgH7BOnfabF8AM9TptXgB3qdeCeQDsBH5Qr5/ALg+DPkH9jnsY9G3qd6v0kLcA76jfB2BryUEfZXwcLjnoK4yP2ZKDfs74eFFy0KsDBP2ivr7koNP7t/26r76+5KDTm+T9OqO+vvSnKUt9vpHeUV9fbNB52FN/CbuYPnmpZX1R+cyYyde91Xzcy7+endrWhxBCCMEbYLMJADalw9QA24F54HM+rqWfmTPADqAHfMtHz2POVsBcw4P/VXMGuN6Qc95UAG8bCrwxZ4BPDTk/moq2v2XNGZWc8gUQySlfAJGc8gUQySlfAJGc8gUQySlfAJGc8gUQySlfAJGc8gUQySlfAJGc8gUQySlfAJGc8gUQySlfAJGc8gUQySlfAJGc8gUQySlfAJGc8gUQySlfAJGc8gUQySlfAJGc8gUQyflfC/D7f04uA6+BV0B32G/jx6Ab5MFu1LUhxKAb5DN5pF8zi0E3yJeLjV7aEGLQ/V86LtkQYtDtN8NuPrPjZqj02IRITvkCiOSUL4BIzlbA15YOu80JYK+7fTkGBTxrKXHenAAutmRcNhXAzZYS39OwS+7NnF4buPCHTRFvmArgGLqOmBLR/UoXTE3aDhhYQcd7YNoUAYdEdnpcAQ6aMuCA88vIHVebcY9oe81eenwacL+5UUuv/TQ9Xcjd+EIIIYQQQgjB/oFf7HgLtHRtrJ4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineTag);
export default __webpack_public_path__ + "static/media/onlineTag.aefbaa8cb5d6e69e831602657254a4fe.svg";
export { ForwardRef as ReactComponent };